import { type RouteRecordRaw } from 'vue-router'

export const integrationsRoutes: RouteRecordRaw[] = [
  {
    path: '/integrations',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'manage-integrations',
        component: () =>
          import('pages/receiver/integrations/ManageIntegrations.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'embed/:tabName',
        name: 'embed-integration',
        component: () =>
          import('pages/receiver/integrations/embed/EmbedIntegration.vue'),
        meta: {
          requiresAuth: true,
          roles: ['X_EMBED'],
        },
      },
      {
        path: 'webhooks',
        name: 'webhooks-integration',
        component: () =>
          import('pages/receiver/integrations/webhooks/WebhookConfig.vue'),
        meta: {
          requiresAuth: true,
          roles: ['X_WEBHOOKS'],
        },
      },
      {
        path: 'webhooks-logs',
        name: 'webhooks-integration-log',
        component: () =>
          import('pages/receiver/integrations/webhooks/WebhooksLogs.vue'),
        meta: {
          requiresAuth: true,
          roles: ['X_WEBHOOKS'],
        },
      },
      {
        path: 'api',
        name: 'api-integration',
        component: () =>
          import('pages/receiver/integrations/api/ManageApi.vue'),
        meta: {
          requiresAuth: true,
          roles: ['X_API'],
        },
      },
      // Custom data
      {
        path: 'custom-data',
        name: 'custom-data-integration',
        component: () =>
          import('pages/receiver/integrations/customData/ManageCustomData.vue'),
        meta: {
          requiresAuth: true,
          roles: ['X_CUSTOM_DATA_EXTRACTOR'],
        },
      },
      {
        path: 'custom-data/create',
        name: 'custom-data-integration-create',
        component: () =>
          import('pages/receiver/integrations/customData/EditCustomData.vue'),
        meta: {
          requiresAuth: true,
          roles: ['X_CUSTOM_DATA_EXTRACTOR'],
        },
      },
      {
        path: 'custom-data/edit/:id',
        name: 'custom-data-integration-edit',
        component: () =>
          import('pages/receiver/integrations/customData/EditCustomData.vue'),
        meta: {
          requiresAuth: true,
          roles: ['X_CUSTOM_DATA_EXTRACTOR'],
        },
      },
      // Power functions
      {
        path: 'power-functions',
        name: 'power-function-integration',
        component: () =>
          import(
            'pages/receiver/integrations/powerFunctions/ManagePowerFunctions.vue'
          ),
        meta: {
          requiresAuth: true,
          roles: ['X_POWER_FUNCTION'],
          fluid: 'container-xxl',
        },
      },
      {
        path: 'power-function/edit/:id',
        name: 'power-function-integration-edit',
        component: () =>
          import(
            'pages/receiver/integrations/powerFunctions/PowerFunctionEdit.vue'
          ),
        meta: {
          requiresAuth: true,
          roles: ['X_POWER_FUNCTION'],
        },
      },
      {
        path: 'power-function/create',
        name: 'power-function-integration-create',
        component: () =>
          import(
            'pages/receiver/integrations/powerFunctions/PowerFunctionCreate.vue'
          ),
        meta: {
          requiresAuth: true,
          roles: ['X_POWER_FUNCTION'],
        },
      },
    ],
  },
]
